<!--BUG REPORT: 
1. images expanding with height of content. Don't want this as it scews the pic.
2. service-col media doesn't center service icons.
-->

<!--TITLE-->
<div class="container-fluid pt-120 pb-5">
    <div class="row title-bar">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-uppercase text-center">Our <span class="text-red">Heating</span> Services</h1>
                        <p class="text-center pt-3">As a locally owned and operated business, Eazy Breezy understands better than anyone the long, cold winters we experience in Alberta. Let our family help your family stay warm this winter. Whether your furnace is falling apart or you are looking to upgrade to a more energy efficient option, call Eazy Breezy for your free in home quote. With over 15 years of experience in the ever changing Heating and Cooling industry, you can rely on us for the most up to date advice on a new climate control system. We are proud to offer you different brands and options to fit your family's budget and needs.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--15 YEARS XP BAR-->
<div class="container-fluid">
    <div class="row xp-bar bg-blue">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-9">
                        <h2 class="text-white text-center">Over 15 Years of Experience</h2>
                        <p class="text-white text-justify pt-3">Trust Eazy Breezy to service your furnace when it fails you. We pride ourselves on our strong service background and customer satisfaction!</p>
                    </div>
                    <div class="col-sm-3 text-center mobile-pt">
                        <i class="fa fa-regular fa-gem"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--SERVICES-->
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 service-col pb-5">
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-red icon-install"></div></div>
                        <div class="service-text">
                            <h1>Furnace Installation</h1>
                            <p class="pt-3">Each home is unique and will require it's own heat loss calculation. We take into account the age of the home, amount of windows in the home and many more factors that can impact the efficiency of your system. It is Eazy Breezy's goal to match your home with the proper size unit to ensure your absolute comfort during the cold Edmonton months. With many different options available, we will help each home owner reach a decision that will meet their needs and budget.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-red icon-maintenance"></div></div>
                        <div class="service-text">
                            <h1>Furnace Maintenance</h1>
                            <p class="pt-3">It is extremely important to keep your furnace running in tip top shape. With regularly scheduled maintenances you ensure the longevity, efficiency and safety of your unit. During a maintenance of your furnace, we will identify any potential costly breakdowns to save you the headache later on. Don't wait until your furnace gives up on one of Alberta's notorious cold snaps, schedule a maintenance with Eazy Breezy today!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-red icon-repair"></div></div>
                        <div class="service-text">
                            <h1>Furnace Repair</h1>
                            <p class="pt-3">In Alberta's harsh winters, your furnace is working extremely hard and failures can happen. We at Eazy Breezy take pride in being able to repair all makes and models, no matter what the age of your furnace is. <span class="text-bold">As a family owned and operated business, we are not there to just upsell you to a new furnace.</span> We will make an honest assessment of your needs and repair if possible.</p>
                            <p class="text-bold pt-4">Before calling for a repair, check the below list…</p>
                            <ol>
                                <li>Your furnace filter is clean. Furnace filters should be changed every 3 - 4 months. A neglected filter can lead to a furnace overheating and components failing.</li>
                                <li>The furnace switch is turned ON. This is the safety switch that provides power to your furnace. Sometimes it could accidentally be turned off.</li>
                                <li>The circuit breaker is turned ON. This will be located on your electrical panel.</li>
                            </ol>
                            <p class="pt-3">If you are able to confirm the above list and your furnace is still not working, please give us a call right away!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 contact-img">
            &nbsp;
        </div>
    </div>
</div>

<!--BOOK AND PHONE BAR-->
<div class="container-fluid">
    <div class="row phone-bar bg-blue">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 border-r pb-mobile-20">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Office</h3>
                        <p class="text-center text-white">587.596.3040</p>
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center border-r pb-mobile-20">
                        <div class="action-button verticle-center-text" routerLink="/contact" href="/contact">
                            <span>BOOK ONLINE</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Dispatch</h3>
                        <p class="text-center text-white">780.964.3299</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--OTHER SERVICES-->
<div class="container-fluid pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="text-center text-uppercase">Other Services</h1>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle rounded-circle">
                            <i class="text-blue fa fa-solid fa-snowflake"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Cooling</h2>
                        <p class="pt-2">Edmonton weather is changing and the need to have climate control through these hot summer months is a must. Our cooling experts will help you beat the heat.<br><a rel="/cooling" href="/cooling" class="text-blue">Read more.</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle rounded-circle">
                            <i class="text-yellow fa fa-solid fa-faucet"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Plumbing</h2>
                        <p class="pt-2">Not just HVAC? That's right! Whether you need a new hot water tank, a pipe repaired, or a drain cleared, our plumbing experts are ready to help.<br><a rel="/plumbing" href="/plumbing" class="text-yellow">Read more.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--GOAL--
<div class="container-fluid pt-5 pb-5">
    <div class="container">
        <div class="row goal-bar bg-red">
            <div class="col-sm-12 col-md-4 d-flex justify-content-center">
                <div class="home-sprite"></div>
            </div>
            <div class="col-sm-12 col-md-8">
                <p class="text-white">...</p>
            </div>
        </div>
    </div>
</div>-->